export function navigateToExternal(url: string) {
  window.location.assign(url)
}
